import { Close } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import FallbackComponent from "../../../../components/fallbackComponent/FallbackComponent";
import { StockItemFragment } from "../../../../models/autogenerated-deliveryService-gql/graphql";
import SerialNumbersInfo from "../serialNumbersInfo/SerialNumbersInfo";

interface StockTableProps {
  items: StockItemFragment[];
}

const StockTable = (props: StockTableProps) => {
  const { t } = useTranslation();
  const { items } = props;

  if (items.length === 0) {
    return (
      <FallbackComponent
        middleIcon={<Close size={32} />}
        text={t("noStocksExist")}
      />
    );
  }

  return (
    <div className="table-container">
      <table className="stock-overview-table">
        <thead>
          <tr>
            <th>{t("materialName")}</th>
            <th>{t("materialNumber")}</th>
            <th>{t("baseUnit")}</th>
            <th>{t("quantity")}</th>
            <th>{t("availableQuantity")}</th>
            <th>{t("batch")}</th>
            <th>{t("serialNumbers")}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            const rowKey = `${item.materialId ?? "none"}-${item.materialNumber ?? "none"}-${item.batch ?? "none"}-${item.baseUnit ?? "none"}-${index}`;

            return (
              <tr key={rowKey}>
                <td>{item.materialName || "-"}</td>
                <td>{item.materialNumber || "-"}</td>
                <td>{item.baseUnit || "-"}</td>
                <td>{item.quantity}</td>
                <td>{item.availableQuantity}</td>
                <td>{item.batch || "-"}</td>
                <td>
                  <SerialNumbersInfo serialNumbers={item.serialNumbers ?? []} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StockTable;
